<div class="chapter-card" [class.chapter-card--selected]="selected">
  <div class="chapter-card__content">
    <div class="chapter-card--loading" *ngIf="false">
      <app-spinner size="medium"></app-spinner>
      <span class="text-uppercase text-12 ml-2">Loading...</span>
    </div>
  
    <div #cardThumbnail class="chapter-card__image" [ngStyle]="getImageStyle()"></div>
  
    <div class="chapter-card__body">
      <div class="chapter-card__title">
        {{ chapter.info.displayName }}
        <span class="text-italic text-dim" *ngIf="!chapter.info.displayName">No title</span>
      </div>
  
      <div class="chapter-card__description" [innerHTML]="shortDescription" *ngIf="shortDescription"></div>
      <div class="chapter-card__description" *ngIf="!shortDescription">
        <span class="text-italic text-dim">No description</span>
      </div>
    
    </div>
    
  </div>
  
  <div class="chapter-card__actions">
    <app-chapter-actions [selected]="selected" [chapter]="chapter"></app-chapter-actions>
  </div>
</div>